/* eslint-disable block-scoped-var */

'use strict';

/* global Clyde, ClydeSitePreferences */

const { generateResponsiveSlickCarousel, generateDefaultSlickCarousel, toastFunction, SUBSCRIPTION_RESUME_URL_KEY, getAddToCartUrlWithToken } = require('../common');
const { rearrangeColorSwatchesinModal } = require('./bonusProductSwatch');
const subscriptionPrice = require('./subscriptionPrice');
const GUEST_WISHLIST_KEY = 'guestWishlistItems';

var baseProducts = require('base/product/base');
var interstitialCart = require('../cart/interstitialCart');
var clydeEnablePreference = $('.enable-clyde-widget-preference').data('enable-clyde');
var clydeWidget;
if (clydeEnablePreference === true) {
    clydeWidget = require('clyde/getClydeWidget.js');
}

/**
 * Finds the element to read add-to-cart values from: the nearest ancestor of the trigger that holds an
 * add-to-cart URL input, or the whole document if there is none. The page header has its own URL input
 * with no token, so a page-wide first match can pick the wrong one.
 *
 * @param {jQuery} [$trigger] - the button that starts the add
 * @return {jQuery} - the scope element
 */
function getAddToCartScope($trigger) {
    var $scope = $trigger && $trigger.length ? $trigger.parent() : $();
    while ($scope.length && !$scope.find('.add-to-cart-url').length) {
        $scope = $scope.parent();
    }
    return $scope.length ? $scope : $(document);
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {jQuery} [$trigger] - the button that starts the add
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl($trigger) {
    return getAddToCartScope($trigger).find('.add-to-cart-url').first().val();
}

/**
 * Retrieves the CSRF token rendered next to the add-to-cart URL, if the markup has one
 *
 * @param {jQuery} [$trigger] - the button that starts the add
 * @return {string} - the token, or an empty string
 */
function getAddToCartCsrfToken($trigger) {
    return getAddToCartScope($trigger).find('.add-to-cart-csrf').first().val() || '';
}

/**
 * Returns a generic error toast using toastFunction
 * @param {string} message - The body message to show
 * @param {string} [title='Error'] - Optional title
 * @returns {jQuery} Toast element
 */
function toastMessage(message) {
    return toastFunction({
        type: 'error',
        title: 'Error',
        message: message
    });
}

/**
 * Returns a success toast using toastFunction
 * @param {string} message - The body message to show
 * @returns {jQuery} Toast element
 */
function successToastMessage(message) {
    return toastFunction({
        type: 'success',
        title: 'Success',
        message: message
    });
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-items .bundle-item').each(function () {
        var pid = $(this).data('pid');
        if (pid) {
            childProducts.push({
                pid: pid,
                quantity: $(this).data('quantity')
            });
        }
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <div class="modal-heading-wrapper">' 
        + '    <div class="modal-heading">' + data.labels.selectprods + '</div>'
        + (data.bonusProductSubCopy ? ('<div class="modal-subheading mt-3">' + data.bonusProductSubCopy + '</div>') : '')
        + '    </div>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            var $modal = $('#chooseBonusProductModal');
            $modal.find('.modal-body').empty();
            $modal.find('.enter-message').text(response.enterDialogMessage);
            $modal.find('.modal-header .close .sr-only').text(response.closeButtonText);
            $modal.find('.modal-body').html(parsedHtml.body);
            $modal.find('.modal-footer').html(parsedHtml.footer);
            // createCarousel(primaryImageUrls, $productContainer);
            $modal.modal('show');
            rearrangeColorSwatchesinModal();
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Initializes the mini cart recommendation carousel.
 * Applies a responsive slick carousel setup for desktop, tablet, and mobile viewports.
 * Hides the product tiles before carousel renders to avoid layout flash.
 * Ensures that injected scripts inside the container are removed.
 */
function initMiniCartRecommendationCarousel() {
    const $carouselContainer = $('.mini-cart-carousel__items > .row');
    const $leftArrowSelector = $('.mini-cart-carousel__items .left-arrow');
    const $rightArrowSelector = $('.mini-cart-carousel__items .right-arrow');

    const slidesToShowDesk = 1;
    const slidesToScrollDesk = 1;
    const slidesToShowTab = 1;
    const slidesToScrollTab = 1;
    const slidesToShowMobile = 1;
    const slidesToScrollMobile = 1;

    try {
        if ($carouselContainer.length > 0) {
            // Remove any injected <script> tags that could break layout
            $carouselContainer.find('script').remove();

            const $products = $carouselContainer.children();
            $products.hide(); // Prevent layout flash before carousel renders

            // Slight delay to ensure layout stability
            setTimeout(() => {
                try {
                    generateResponsiveSlickCarousel(
                        $carouselContainer,
                        $leftArrowSelector,
                        $rightArrowSelector,
                        slidesToShowDesk,
                        slidesToScrollDesk,
                        slidesToShowMobile,
                        slidesToScrollMobile,
                        slidesToShowTab,
                        slidesToScrollTab,
                        false,
                        true,
                        { variableWidth: true }
                    );

                    // Show products after initialization
                    $carouselContainer.children().show();
                } catch (e) {
                    console.error('Mini cart carousel initialization failed:', e);
                }
            }, 50);
        } else {
            console.warn('Mini cart carousel selector not rendered');
        }
    } catch (e) {
        console.error('Mini cart carousel error:', e);
    }
}

/**
 * Initializes the mini cart Interstitial carousel.
 */
function initInterstitialCartCarousel() {
    const $carouselContainer = $('.interstitial-cart-tiles');

    const slidesToShowDesk = 2.5;
    const slidesToScrollDesk = 1;
    const slidesToShowTab = 2.2;
    const slidesToScrollTab = 1;
    const slidesToShowMobile = 2.5;
    const slidesToScrollMobile = 1;

    try {
        if ($carouselContainer.length > 0) {
            // Remove any injected <script> tags that could break layout
            $carouselContainer.find('script').remove();

            const $products = $carouselContainer.children();
            $products.hide(); // Prevent layout flash before carousel renders

            // Slight delay to ensure layout stability
            setTimeout(() => {
                try {
                    generateResponsiveSlickCarousel(
                        $carouselContainer,
                        slidesToShowDesk,
                        slidesToScrollDesk,
                        slidesToShowMobile,
                        slidesToScrollMobile,
                        slidesToShowTab,
                        slidesToScrollTab
                    );

                    // Show products after initialization
                    $carouselContainer.children().show();
                } catch (e) {
                    console.error('Mini cart Interstitial carousel initialization failed:', e);
                }
            }, 50);
        } else {
            console.warn('Mini cart Interstitial carousel selector not rendered');
        }
    } catch (e) {
        console.error('Mini cart Interstitial carousel error:', e);
    }
}

/**
 * addToCartPopUpHTML is to show add to cart model addToCartPopUpHTML
 * @param {Object} response response
 * */
function addToCartPopUpHTML(response) {
    var popEle = $('#add-to-cart-pop-up-html');
    if (popEle.length > 0) {
        popEle.scrollTop(0);
        popEle.find('.modal-body').scrollTop(0);
        popEle.find('.modal-content').scrollTop(0);
        popEle.find('.simple-product').html(response.popUpHtml);
        interstitialCart.injectDynamicPrices(response);
        $('#viewCartButtonQty').text(`(${response.respQty})`);
        if (response && response.approachingDiscounts && response.approachingDiscounts[0] && response.approachingDiscounts[0].discountMsg && response.approachingDiscounts[0].discountMsg.length > 0) {
            popEle.find('.approaching-discounts').remove();
            popEle.find('.modal-footer').after('<div class="approaching-discounts"> <div class="single-approaching-discount text-center"> ' + response.approachingDiscounts[0].discountMsg + '</div> </div>');
        };
        popEle.modal('show');
        // Always destroy slick first if it exists
        $('.mini-cart-carousel__items > .row, .interstitial-cart-tiles')
            .filter('.slick-initialized')
            .each(function () {
                $(this).slick('unslick');
            });

        // Hide carousel wrapper until re-initialized
        $('.mini-cart-carousel__items, .interstitial-cart-addons')
            .each(function () {
                $(this).css('visibility', 'hidden');
            });

        // Reinitialize carousel after DOM update
        setTimeout(() => {
            initMiniCartRecommendationCarousel();
            var hasInterstitialTiles = popEle.find('.interstitial-cart-tiles').length > 0;
            if (hasInterstitialTiles) {
                initInterstitialCartCarousel();
                setTimeout(function () {
                    popEle.find('.interstitial-cart-tiles img.lazyload').each(function () {
                        if (window.lazysizes && window.lazysizes.loader && window.lazysizes.loader.unveil) {
                            window.lazysizes.loader.unveil(this);
                        }
                    });
                }, 300);
            }
            setTimeout(() => {
                $('.mini-cart-carousel__items, .interstitial-cart-addons')
                    .each(function () {
                        $(this).css('visibility', 'visible');
                    });
                $('body').trigger('cartCarousel:setup', {});
            }, 200);
        }, 1000); 
    }
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * Shows add-to-cart modal when popUpHtml is present; otherwise shows toast.
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    // Exported on `baseProducts`, which base/util.processInclude iterates as init
    // functions on cart/search/wishlist/warranty entry bundles — those invocations
    // pass no args, so bail out when there's no cart-add response to process.
    if (!response) {
        return;
    }
    $('.minicart').trigger('count:update', response);

    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if (response.error !== true) {
            addToCartPopUpHTML(response);
            if ($('.cart-page').length > 0) {
                $('body').trigger('cart:lineItemRefresh', response);
            }
        } else {
            $('.add-to-basket-alert').html(response.message);
        }

        setTimeout(function () {
            if ($('.popover-bottom').hasClass('show') && $('.plp-add-to-cart').length) {
                $('.popover-bottom').removeClass('show');
            }
            $('.add-to-basket-alert').remove();
        }, 5000);
    }
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    var quantitySelected;
    if ($el && $('.set-items').length) {
        quantitySelected = $($el).closest('.product-detail').find('.quantity-select');
    } else if ($el && $('.product-bundle').length) {
        var quantitySelectedModal = $($el).closest('.modal-footer').find('.quantity-select');
        var quantitySelectedPDP = $($el).closest('.bundle-footer').length > 0 ? $($el).closest('.bundle-footer').find('.quantity-select') : $('.quantity-select');
        if (quantitySelectedModal.val() === undefined) {
            quantitySelected = quantitySelectedPDP;
        } else {
            quantitySelected = quantitySelectedModal;
        }
    } else if ($el && $('.byo-product').length) {
        var quantitySelectedBYO = $($el).closest('.byo-footer').length > 0 ? $($el).closest('.byo-footer').find('.quantity-select') : $('.quantity-select');
        quantitySelected = quantitySelectedBYO;
    } else {
        quantitySelected = $('.quantity-select');
    }
    return quantitySelected;
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="'
            + attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
            var $labelContainer = $productContainer.find('.' + attr.id + '.non-input-label');
            $labelContainer.find('.' + attr.id + '-name').text(attrValue.displayValue);
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    var $attr = '[data-attr="' + attr.id + '"]';
    var $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer
            .find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.url)
            .removeAttr('disabled');

        if (!attrValue.selectable) {
            $attrValue.attr('disabled', true);
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color', 'size'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var productAvailability = response.product && response.product.availability;
    var availabilityMessages = productAvailability && productAvailability.messages ? productAvailability.messages : [];
    var $availabilityScope = $productContainer && $productContainer.length
        ? $('.product-availability', $productContainer)
        : $('.product-availability');
    var isBonusModal = $productContainer && $productContainer.parents('.choose-bonus-product-dialog').length > 0;

    if (response && response.product && response.product.comingSoon && response.comingSoonText) {
        $availabilityScope.removeClass('d-none');
        $availabilityScope.find('.availability-msg').addClass('coming-soon');
        $availabilityScope.find('.coming-soon-content-asset').removeClass('d-none');
        availabilityValue = response.comingSoonText;
    } else if (availabilityMessages.length > 0) {
        $availabilityScope.removeClass('d-none');
        availabilityMessages.forEach(function (message) {
            availabilityValue += message;
        });
        $availabilityScope.find('.availability-msg').removeClass('coming-soon');
        $availabilityScope.find('.coming-soon-content-asset').addClass('d-none');
    } else if (isBonusModal && response.product && response.product.available !== undefined) {
        // Bonus modal fallback when availability.messages is empty
        availabilityValue = response.product.availability
            && response.product.availability.message
            && response.product.availability.message[0];
        if (availabilityValue) {
            $availabilityScope.removeClass('d-none');
        } else {
            $availabilityScope.addClass('d-none');
        }
        $availabilityScope.find('.availability-msg').removeClass('coming-soon');
        $availabilityScope.find('.coming-soon-content-asset').addClass('d-none');
    } else {
        $availabilityScope.addClass('d-none');
        $availabilityScope.find('.coming-soon-content-asset').addClass('d-none');
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Shows or hides the product badge and updates its text and colours when the selected variant changes. 
 *
 * @param {Object} response - Ajax response from the server
 * @param {jQuery} $productContainer - DOM element for the current product
 */
function updateProductLabel(response, $productContainer) {
    var labelText = response.product && response.product.labelText;
    var labelColor = response.product && response.product.labelColor;
    var labelTextColor = response.product && response.product.labelTextColor;

    var $badge = $productContainer.find('.product-badge:not(.discontinued-badge, .secondary-product-badge, .product-tile .product-badge)');

    if (labelText && labelColor) {
        // Badge element may not exist in DOM when the initial product had no label
        if (!$badge.length) {
            $badge = $('<div class="product-badge"></div>');
            $productContainer.find('.product-name').first().before($badge);
        }
        $badge
            .text(labelText)
            .attr('data-bg-color', labelColor)
            .attr('data-text-color', labelTextColor || '')
            .css('background-color', labelColor)
            .css('color', labelTextColor || '')
            .removeClass('d-none');
    } else if ($badge.length) {
        $badge.addClass('d-none');
    }
}

/**
 * Shows, updates, or removes the secondary label badge(s) (e.g. "Web Exclusive") when the
 * selected variant changes. Mirrors updateProductLabel(), but for .secondary-product-badge,
 * which handleVariantResponse previously left untouched on AJAX variant switches.
 *
 * @param {Object} response - Ajax response from the server
 * @param {jQuery} $productContainer - DOM element for the current product
 */
function updateSecondaryLabels(response, $productContainer) {
    var secondaryLabels = (response.product && response.product.secondaryLabels) || [];
    var $productName = $productContainer.find('.product-name').first();
    var $secondaryLabelsContainer = $productName.length
        ? $productName.prev('.secondary-labels')
        : $productContainer.find('.secondary-labels').first();

    if (!$secondaryLabelsContainer.length) {
        if (!secondaryLabels.length) {
            return;
        }
        $secondaryLabelsContainer = $('<div class="secondary-labels"></div>');
        if ($productName.length) {
            $productName.before($secondaryLabelsContainer);
        } else {
            $productContainer.prepend($secondaryLabelsContainer);
        }
    }

    $secondaryLabelsContainer.empty();

    secondaryLabels.slice(0, 2).forEach(function (label) {
        if (!label.text) {
            return;
        }
        $('<div class="product-badge secondary-product-badge"></div>')
            .attr('data-bg-color', label.backgroundColor || '')
            .attr('data-text-color', label.textColor || '')
            .css('background-color', label.backgroundColor || '')
            .css('color', label.textColor || '')
            .text(label.text)
            .appendTo($secondaryLabelsContainer);
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': '
                    + attribute.value + '</div>';
            });
        }
    });

    return html;
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
}

/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function createCarousel(imgs, $productContainer) {
    var carousel = $productContainer.find('.carousel');
    if (carousel && carousel.length > 0) {
        $(carousel).carousel('dispose');
        var carouselId = $(carousel).attr('id');
        $(carousel).empty().append('<ol class="carousel-indicators"></ol><div class="carousel-inner" role="listbox"></div><a class="carousel-control-prev" href="#' + carouselId + '" role="button" data-slide="prev"><span class="fa icon-prev" aria-hidden="true"></span><span class="sr-only">' + $(carousel).data('prev') + '</span></a><a class="carousel-control-next" href="#' + carouselId + '" role="button" data-slide="next"><span class="fa icon-next" aria-hidden="true"></span><span class="sr-only">' + $(carousel).data('next') + '</span></a>');
        for (var i = 0; i < imgs.length; i++) {
            $('<div class="carousel-item"><img src="' + imgs[i].url + '" class="d-block img-fluid" alt="' + imgs[i].alt + ' image number ' + parseInt(imgs[i].index, 10) + '" title="' + imgs[i].title + '" itemprop="image" /></div>').appendTo($(carousel).find('.carousel-inner'));
            $('<li data-target="#' + carouselId + '" data-slide-to="' + i + '" class=""></li>').appendTo($(carousel).find('.carousel-indicators'));
        }
        $($(carousel).find('.carousel-item')).first().addClass('active');
        $($(carousel).find('.carousel-indicators > li')).first().addClass('active');
        if (imgs.length === 1) {
            $($(carousel).find('.carousel-indicators, a[class^="carousel-control-"]')).detach();
        }
        $(carousel).carousel();
        $($(carousel).find('.carousel-indicators')).attr('aria-hidden', true);
    }
}

/**
 * Updates bonus product modal price when variant changes.
 * Preserves existing "free" label and refreshes strike price.
 *
 * @param {Object} response - Ajax response object after variant selection
 * @param {jQuery} $productContainer - DOM element for current bonus product
 */
function updateBonusModalPrice(response, $productContainer) {
    var $bonusPriceContainer = $productContainer.find('.bonus-product-price');
    if (!$bonusPriceContainer.length || !response || !response.product) {
        return;
    }

    var variantPriceHtml = response.product.price && response.product.price.html;
    var variantPriceText = variantPriceHtml ? $('<div>').html(variantPriceHtml).text().trim() : '';
    var existingPriceText = $bonusPriceContainer.find('.list-price').first().text().trim();
    var $freeLabel = $bonusPriceContainer.find('.bonus-free-label').first().clone();
    var priceValue = variantPriceText || existingPriceText;

    $bonusPriceContainer.empty();

    if ($freeLabel.length) {
        $bonusPriceContainer.append($freeLabel);
    }

    if (priceValue) {
        $bonusPriceContainer.append(
            $('<span class="ml-0 strike-through list-price"></span>').text(priceValue)
        );
    }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }
    }

    // Update primary images
    var primaryImageUrls = response.product.images.large;
    createCarousel(primaryImageUrls, $productContainer);
  
    // Update pricing
    if (!isChoiceOfBonusProducts && $('.byo-product').length === 0 && $('.byo-thirsti-product').length === 0) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
        subscriptionPrice.onVariantResponse(response.product, $productContainer);
    }
  
    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);
  
    updateAvailability(response, $productContainer);
    updateProductLabel(response, $productContainer);
    updateSecondaryLabels(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
        updateBonusModalPrice(response, $productContainer);

        if (response.product && response.product.images && response.product.images.large && response.product.images.large.length) {
            var firstImage = response.product.images.large[0];
            var selectedProductUrlForImage = response.product.selectedProductUrl || '';
            $productContainer.find('.primary-images .bonus-product-pdp-link')
                .attr('href', selectedProductUrlForImage)
                .find('img')
                .attr('src', firstImage.url)
                .attr('alt', firstImage.alt || response.product.productName || '')
                .attr('title', firstImage.title || response.product.productName || '');
        }
    } else {

        // Update product name
        $productContainer.find('.product-name').text(response.product.productName);

        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);

        $productContainer.find('.cart-and-ipay').replaceWith(response.renderedTemplate);
        $productContainer.find('.product-details-accordion-item').replaceWith(response.renderedProductDetailsOnPdpPageTemplate);
        $('body').trigger('detail:initStickyAddToCart');

        var addOnIds = response.product ? response.product.partsAndAccessories : [];
        var $addOnsBox = $productContainer.find('.update-add-ons');
        // Each variant selection gets a new request id so a slower tile chain from an
        // earlier selection cannot re-insert a stale carousel after a faster switch.
        var addOnsRequestId = ($productContainer.data('addOnsRequestId') || 0) + 1;
        $productContainer.data('addOnsRequestId', addOnsRequestId);

        if (addOnIds && addOnIds.length > 0) {
            var sampleUrl = $productContainer.find('[data-url]').first().attr('data-url') || '';
            var tileShowBaseUrl = '';
            if (sampleUrl) {
                var urlBase = sampleUrl.split('?')[0];
                tileShowBaseUrl = urlBase.replace(/\/[^/]+$/, '/Tile-Show');
            }

            var addOnsTitle = $addOnsBox.length ? $addOnsBox.find('h6').text() : response.addonAccessoriesText || '';

            var $tempContainer = $('<div/>');
            for (var t = 0; t < addOnIds.length; t++) {
                $tempContainer.append(
                    '<div class="add-ons-carousel-inner pd-tile-wrapper js-tile-position" '
                    + 'data-position="' + (t + 1) + '" '
                    + 'data-addon-pid="' + addOnIds[t] + '"></div>'
                )
            }

            var $tiles = $tempContainer.find('.pd-tile-wrapper[data-addon-pid]');
            var tileIndex = 0;

            var loadNextTile = function () {
                if (addOnsRequestId !== $productContainer.data('addOnsRequestId')) {
                    return;
                }

                if (tileIndex >= $tiles.length) {
                    var $loadedTiles = $tempContainer.find('.add-ons-carousel-inner');

                    if ($loadedTiles.length === 0) {
                        return;
                    }

                    var addOnsHtml = '<div class="add-ons-carousel-box update-add-ons">'
                        + '<h6>' + $('<span/>').text(addOnsTitle).html() + '</h6>'
                        + '<div class="add-ons-carousel-container accessories-carousel">'
                        + $tempContainer.html()
                        + '</div>'
                        + '<div class="control-bar navigation-container d-none d-md-flex">'
                        + '<div class="nav-arrows">'
                        + '<button class="btn icon-secondary left-arrow nav-arrow" aria-label="Previous" type="button" data-slide="prev"></button>'
                        + '<button class="btn icon-secondary right-arrow nav-arrow" aria-label="Next" type="button" data-slide="next"></button>'
                        + '</div></div></div>';

                    if ($addOnsBox.length) {
                        var $existingSlider = $addOnsBox.find('.add-ons-carousel-container');
                        if ($existingSlider.hasClass('slick-initialized')) {
                            $existingSlider.slick('unslick');
                        }
                        $addOnsBox.replaceWith(addOnsHtml);
                    } else {
                        var $anchor = $productContainer.find('.compare-helptext-block, .product-recommendations').first();
                        if ($anchor.length) {
                            $anchor.before(addOnsHtml);
                        }
                    }

                    var $newSlider = $productContainer.find('.update-add-ons .add-ons-carousel-container');
                    var $newLeftArrow = $productContainer.find('.update-add-ons .left-arrow');
                    var $newRightArrow = $productContainer.find('.update-add-ons .right-arrow');
                    if ($newSlider.length > 0) {
                        generateDefaultSlickCarousel($newSlider, $newLeftArrow, $newRightArrow, 2, 2);
                    }
                    return;
                }

                var $tile = $tiles.eq(tileIndex);
                var pid = $tile.attr('data-addon-pid');
                var tileUrl = tileShowBaseUrl + '?pid=' + pid
                    + '&swatches=true&ratings=true&showATCButton=true'
                    + '&partsAndAccessories=true&pageType=AddOnsAndAccessories';

                $.ajax({ url: tileUrl, method: 'GET' })
                    .done(function (html) {
                        $tile.html(html);
                    })
                    .fail(function () {
                        $tile.remove();
                    })
                    .always(function () {
                        tileIndex++;
                        loadNextTile();
                    });
            };

            loadNextTile();
        } else if ($addOnsBox.length) {
            var $existingAddOnsSlider = $addOnsBox.find('.add-ons-carousel-container');
            if ($existingAddOnsSlider.hasClass('slick-initialized')) {
                $existingAddOnsSlider.slick('unslick');
            }
            $addOnsBox.remove();
        }

        // Update product recommendations section for the selected variant.
        // Same approach as add-ons: load tiles into a detached container via
        // individual Tile-Show AJAX calls; only replace the carousel if at
        // least one tile loads. If the new variant has no recommendations,
        // remove the existing section.
        var recommendations = response.product ? response.product.recommendations : [];
        var $recsWrapper = $productContainer.find('.good-better-best-carousel-wrapper');
        var recsRequestId = ($productContainer.data('recsRequestId') || 0) + 1;
        $productContainer.data('recsRequestId', recsRequestId);

        if (recommendations && recommendations.length > 0) {
            var recSampleUrl = $productContainer.find('[data-url]').first().attr('data-url') || '';
            var recTileShowBaseUrl = '';
            if (recSampleUrl) {
                var recUrlBase = recSampleUrl.split('?')[0];
                recTileShowBaseUrl = recUrlBase.replace(/\/[^/]+$/, '/Tile-Show');
            }

            var recsTitle = '';
            if ($recsWrapper.length) {
                recsTitle = $recsWrapper.find('h6.title').html();
            }
            var newRecsTitle = response.product.upsellHeadline || recsTitle || '';

            var $recTempContainer = $('<div/>');
            for (var r = 0; r < recommendations.length; r++) {
                var rec = recommendations[r];
                var tileHtml = '<div class="' + rec.id + ' js-tile-position" '
                    + 'data-position="' + (r + 1) + '" '
                    + 'data-rec-pid="' + rec.id + '">';
                if (rec.upsellShowDescription && rec.shortDescription) {
                    tileHtml += '<div class="description">' + rec.shortDescription + '</div>';
                }
                if (rec.upsellText) {
                    tileHtml += '<div class="description-upsell">' + rec.upsellText + '</div>';
                }
                tileHtml += '<div class="rec-tile-content"></div></div>';
                $recTempContainer.append(tileHtml);
            }

            var $recTiles = $recTempContainer.find('[data-rec-pid]');
            var recTileIndex = 0;

            var loadNextRecTile = function () {
                if (recsRequestId !== $productContainer.data('recsRequestId')) {
                    return;
                }

                if (recTileIndex >= $recTiles.length) {
                    var $loadedRecTiles = $recTempContainer.find('[data-rec-pid]');

                    if ($loadedRecTiles.length === 0) {
                        return;
                    }

                    var recsHtml = '<div class="good-better-best-carousel-wrapper carousel-with-dots">'
                        + '<h6 class="title">' + newRecsTitle + '</h6>'
                        + '<div class="good-better-best-carousel" id="good-better-best-carousel">'
                        + $recTempContainer.html()
                        + '</div>'
                        + '<div class="control-bar navigation-container row d-none d-md-flex">'
                        + '<div class="nav-arrows">'
                        + '<button class="btn icon-secondary left-arrow nav-arrow" aria-label="Previous" type="button" data-slide="prev"></button>'
                        + '<button class="btn icon-secondary right-arrow nav-arrow" aria-label="Next" type="button" data-slide="next"></button>'
                        + '</div></div></div>';

                    if ($recsWrapper.length) {
                        var $existingRecSlider = $recsWrapper.find('.good-better-best-carousel');
                        if ($existingRecSlider.hasClass('slick-initialized')) {
                            $existingRecSlider.slick('unslick');
                        }
                        $recsWrapper.replaceWith(recsHtml);
                    } else {
                        var $recAnchor = $productContainer.find('.compare-helptext-block').first();
                        if ($recAnchor.length) {
                            $recAnchor.before(recsHtml);
                        }
                    }

                    var $newRecSlider = $productContainer.find('.good-better-best-carousel');
                    var $newRecLeftArrow = $productContainer.find('.good-better-best-carousel-wrapper .left-arrow');
                    var $newRecRightArrow = $productContainer.find('.good-better-best-carousel-wrapper .right-arrow');
                    if ($newRecSlider.length > 0) {
                        generateDefaultSlickCarousel($newRecSlider, $newRecLeftArrow, $newRecRightArrow, 1.025, 1);
                    }
                    return;
                }

                var $recTile = $recTiles.eq(recTileIndex);
                var recPid = $recTile.attr('data-rec-pid');
                var recTileUrl = recTileShowBaseUrl + '?pid=' + recPid
                    + '&swatches=true&ratings=true&showATCButton=false'
                    + '&recommendationSwatch=true&pageType=upgradeCarousel';

                $.ajax({ url: recTileUrl, method: 'GET' })
                    .done(function (html) {
                        $recTile.find('.rec-tile-content').replaceWith(html);
                    })
                    .fail(function () {
                        $recTile.remove();
                    })
                    .always(function () {
                        recTileIndex++;
                        loadNextRecTile();
                    });
            };

            loadNextRecTile();
        } else if ($recsWrapper.length) {
            var $existingRecCarousel = $recsWrapper.find('.good-better-best-carousel');
            if ($existingRecCarousel.hasClass('slick-initialized')) {
                $existingRecCarousel.slick('unslick');
            }
            $recsWrapper.remove();
        }

        // Update short description 
        $productContainer.find('.short-description-text').html(response.product.shortDescription || '');
        var $productAlert = $productContainer.find('.product-alert').empty();
        if (response.product.productAlert) {
            $productAlert.append($('<div class="product-alert-message"></div>').text(response.product.productAlert));
        }

        // Update product model ID
        var $productModel = $productContainer.find('.product-model');
        if ($productModel.length && response.product.id) {
            var currentText = $productModel.text();
            var labelText = currentText.split(':')[0];
            $productModel.text(labelText + ': ' + response.product.id);
        }

        // Update free gift bonus product section on variant switch
        var $freeGiftSection = $productContainer.find('[data-free-gift-bonus="section"]');
        if ($freeGiftSection.length && typeof response.renderedFreeGiftHtml !== 'undefined') {
            $freeGiftSection.html(response.renderedFreeGiftHtml);
        }
    }
  
    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));


    // Update product name
    if (response && response.product && response.product.productName) {
        var selectedProductUrl = response.product.selectedProductUrl || '';
        $productContainer.find('.product-name .bonus-product-pdp-link')
            .text(response.product.productName)
            .attr('title', response.product.productName)
            .attr('href', selectedProductUrl);
    }
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    var $qtySelect = $productContainer.find('.quantity-select');
    var $qtyInput = $productContainer.find('.qty-input');
    var inputValue = parseInt($qtyInput.val(), 10);
    if (!inputValue || isNaN(inputValue)) {    //eslint-disable-line
        inputValue = parseInt($qtySelect.val(), 10) || 1;
    }
    if ($productContainer.parent('.bonus-product-item').length <= 0) {
        var optionsHtml = quantities.map(function (quantity) {
            var selected = quantity.selected ? ' selected ' : '';
            return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"'
                + selected + '>' + quantity.value + '</option>';
        }).join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
    $qtySelect.val(inputValue);
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $('body').trigger(
            'product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer }
        );
        if ($('.byo-product').length) {
        // eslint-disable-next-line no-param-reassign
            selectedValueUrl += (selectedValueUrl.indexOf('?') !== -1 ? '&' : '?') + 'byoVariant=true';
        }
        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                try{
                    handleVariantResponse(data, $productContainer);
                    updateOptions(data.product.optionsHtml, $productContainer);
                    updateQuantities(data.product.quantities, $productContainer);
                    $('body').trigger(
                        'product:afterAttributeSelect',
                        { data: data, container: $productContainer }
                    );

                    // Update canonical on variant change
                    if (data && data.product) {
                        let canonicalTag = document.querySelector("link[rel='canonical']");
                        
                        // Get clean pathname (without query params)
                        let pathParts = window.location.pathname.split('/');
                        
                        // Replace last part with variant ID
                        pathParts[pathParts.length - 1] = data.product.id + '.html';
                        
                        let newUrl = window.location.origin + pathParts.join('/');

                        if (canonicalTag) {
                            canonicalTag.setAttribute("href", newUrl);
                        } else {
                            let link = document.createElement("link");
                            link.rel = "canonical";
                            link.href = newUrl;
                            document.head.appendChild(link);
                        }
                    }

                    // Skip PDP-specific updates when in bonus modal (OOTB: modal changes must not affect PDP)
                    var isBonusModal = $productContainer.closest('.choose-bonus-product-dialog').length > 0;
                    if (!isBonusModal && data.product) {
                        var gtmProductData = {
                            item_id : data.product.id ? data.product.id : '',
                            item_name : data.product.productName ? data.product.productName : '',
                        }
                        window.gtmTagManager.gtmVariationUpdateData(gtmProductData);
                        // Hide/Show Order Groove wrapper in PDP
                        var ogWrapper = $('.og-wrapper');
                        if (data.product.subscriptionEnabled) {
                            ogWrapper.show();
                        } else {
                            ogWrapper.hide();
                        }
                    }
                    if (!isBonusModal && data.error && data.quantityError && data.quantityError.length > 0) {
                        $('.qty-wrapper .qty-error').empty().append(data.quantityError)
                    
                        // Find the nearest product container and disable the add-to-cart button
                        var $container = $('.qty-wrapper').closest('.product-detail.product-wrapper');
                        var $button = $container.find('.add-to-cart');
                        $button.attr('disabled', true).addClass('disabled');
                    }
                    if (!isBonusModal && $('.byo-product').length) {
                        $('.variantion-add-on').html(data.addOnTemplate);
                        if ($('.variantion-add-on-details')){
                            $('.variantion-add-on-details').html(data.addOnDetailTemplate);
                        }
                        $('.byo-choose-option:not(:checked)').prop('disabled', false);
                        $('.byo-choose-option:checked').prop('checked', false);
                        $('.byo-choose-option.out-of-stock').prop('disabled', true);
                        var byoMaxOptionsSelection = $('.choose-add-on').data('byomaxoptionsselection');
                        var totalQtyAddOn = 0;
                        var $stickyAddToCart = $('.sticky-fixed button.add-to-cart-global');
                        var $addToCart = $('button.add-to-cart');
                        $('.byo-choose-option:checked').each(function () {
                            totalQtyAddOn += 1;
                        });
                        if ($('.byo-thirsti-product').length){
                            $('.byo-flavour-container').each(function () {
                                if ($(this).find('img').attr('data-pid')) {
                                    totalQtyAddOn += 1;
                                }
                            });
                        }    
                        if (byoMaxOptionsSelection > 0 && byoMaxOptionsSelection !== totalQtyAddOn) {
                            $stickyAddToCart.prop('disabled', true);
                            $addToCart.attr('disabled', true);
                        } else if (byoMaxOptionsSelection === $('.byo-choose-option:checked').length) {
                            var enable = true;
                            enable = $('.bundle-item .product-availability').toArray().every(function (item) {
                                return $(item).data('available') && $(item).data('ready-to-order');
                            });
                            $stickyAddToCart.attr('disabled', !enable);
                            $addToCart.attr('disabled', !enable);
                        }
                    }
                } catch (error) {
                    $.spinner().stop();
                }
                finally{
                    $.spinner().stop();
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Overriding base.js colorAttribute function
 * */
function colorAttribute() {
    // Namespace + .off() before .on() so repeated PDP reinitialization (this runs on
    // every processInclude/cart refresh) does not stack duplicate delegated handlers,
    // which caused multiple attributeSelect() AJAX calls per click and a loader that
    // never stopped after ~18 variation switches.
    $(document).off('click.colorAttribute', '[data-attr="color"] button, [data-attr="size"] button')
        .on('click.colorAttribute', '[data-attr="color"] button, [data-attr="size"] button', function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            if ($(this).attr('disabled')) {
                return;
            }
            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-quickview');
            }

            var isBonusModal = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
            var isBYO = $('.byo-product').length > 0;

            // Only pushState if not handling a popstate event (to prevent history loop)
            if (!isBYO  && !isBonusModal && !window.isHandlingPopstate) {
                const productUrl = $(this).data('product-url');
                if (productUrl) {
                    window.history.pushState({ path: productUrl }, '', productUrl);
                }
            }

            attributeSelect($(this).attr('data-url'), $productContainer);
            $.spinner().stop();
        });
}

/**
 * Update Listrak cart data.
 *
 * @param {string} data - updated data
 */
function ltkUpdateCartData(data) {
    $('script[src*="ltkSendSCA.js"]').attr('ltk-data-sca', data);

    if (typeof renderSCA !== 'undefined') {
        renderSCA(); //eslint-disable-line
    }
}

/**
 * Add Listrak SCA script.
 *
 * @param {Object} data - updated data
 */
function ltkAppendSCAScript(data) {
    if (data){
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.defer = true;
        script.src = data.ltkScriptSrc;
        script.setAttribute('ltk-data-sca', data.SCA);
        script.setAttribute('ltk-data-url', data.ltkDataUrl);
        $('head').append(script);
        $.getScript(data.ltkScriptSrc, function () {
            ltkUpdateCartData(data.SCA);
        });
    }
}

/**
 * function used to add clyde product into cart
 * @param {*} thisValue context for element
 * @param {*} isSubscribed status of subscription product
 * @param {*} optinData subscription optin data
 */
function clydeAddProductToCart(thisValue, isSubscribed, optinData) {
    var addToCartUrl;
    var pid;
    var pidsObj;
    var setPids;
    var pageType = '';
    $('body').trigger('product:beforeAddToCart', thisValue);

    if (thisValue.hasClass('plp-add-to-cart') && thisValue.hasClass('plp-add-to-cart') === true) {
        pageType = 'plp';
    }

    if ($('.set-items').length && thisValue.hasClass('add-to-cart-global')) {
        setPids = [];

        $('.product-detail').each(function () {
            if (!thisValue.hasClass('product-set-detail')) {
                setPids.push({
                    pid: thisValue.find('.product-id').text(),
                    qty: thisValue.find('.quantity-select').val(),
                    options: getOptions(thisValue)
                });
            }
        });
        pidsObj = JSON.stringify(setPids);
    }
    let byoAddonProducts = [];
    if ($('.byo-product').length && pageType !== 'plp'){

        $('.byo-choose-option:checked').each(function () {
            byoAddonProducts.push(
                {
                    pid: $(this).val(),
                    quantity: 1
                }
            );
        });
        if ($('.byo-thirsti-product').length){

            $('.byo-flavour-container').each(function () {
                var exists = byoAddonProducts.some(item => item.pid === $(this).find('img').attr('data-pid'));
                if (!exists){
                    byoAddonProducts.push(
                        {
                            pid: $(this).find('img').attr('data-pid'),
                            quantity: $(this).find('img').attr('data-qty')
                        }
                    );
                }
            });
        }
        byoAddonProducts = byoAddonProducts.length ? JSON.stringify(byoAddonProducts) : [];
    }

    pid = pageType === 'plp' ? thisValue.data('pid') : baseProducts.getPidValue(thisValue);

    var $productContainer = thisValue && thisValue.closest('.product-detail');
    if (!$productContainer.length) {
        $productContainer = thisValue.closest('.quick-view-dialog').find('.product-detail');
    }

    addToCartUrl = getAddToCartUrl(thisValue);

    var form = {
        pid: pid,
        pidsObj: pidsObj,
        childProducts: getChildProducts(),
        quantity: pageType === 'plp' ? thisValue.data('qty') : getQuantitySelected(thisValue),
        isSubscribed: isSubscribed,
        pageType: pageType,
        byoAddonProducts: byoAddonProducts,
        tracking: optinData ? JSON.stringify(optinData) : ''
    };

    var clydeWidgets = (typeof ClydeSitePreferences !== 'undefined' && ClydeSitePreferences.CLYDE_WIDGET_ENABLED) || false;

    if (typeof Clyde !== 'undefined' && clydeWidgets && clydeEnablePreference) {
        var selectedContract = Clyde.getSelectedContract();
        if (selectedContract) {
            form = clydeWidget.getSelectedClydeContract(form);
        }
    }

    if (!$('.bundle-item').length && pageType !== 'plp') {
        form.options = getOptions($productContainer);
    }
    thisValue.trigger('updateAddToCartFormData', form);
    if (addToCartUrl) {
        $.spinner().start();

        getAddToCartUrlWithToken(addToCartUrl, getAddToCartCsrfToken(thisValue)).then(function (urlWithToken) {
            $.ajax({
                url: urlWithToken,
                method: 'POST',
                data: form,
                success: function (data) {
                    handlePostCartAdd(data);
                    $('body').trigger('product:afterAddToCart', data);
                    if (data.error) {
                        // Detect PLP/Search using a class on the button or product tile
                        var $container = thisValue.closest('.product-tile, .product-detail.product-wrapper');
                        var $button = $container.find('.add-to-cart');

                        // If message exists, show the error
                        if (data.message) {
                            // In PDP check low/limited stock products max limit and append qty error message not toast error message
                            if (data.limitedStock && thisValue.hasClass('add-to-cart')) {
                                thisValue.closest('.attributes').find('.qty-wrapper .qty-error').empty().append(data.message);
                            } else {
                                var $toast = toastMessage(data.message);
                                $('.generic-toast-message-wrapper').empty();
                                $('.generic-toast-message-wrapper').append($toast);
                                setTimeout(function () {
                                    $toast.fadeOut(3000, function () {
                                        $(this).remove();
                                    });
                                }, 5000);
                            }
                        }
                        // Disable the button if an error occurs
                        $button.attr('disabled', true).addClass('disabled');
                    }
                    $.spinner().stop();
                    baseProducts.miniCartReportingUrl(data.reportingURL);

                    // Trigger Listrak script for add to cart event.
                    if (data.SCA) {
                        if (!$('script[src*="ltkSendSCA.js"]').length) {
                            ltkAppendSCAScript(data);
                        } else {
                            ltkUpdateCartData(data.SCA);
                        }
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }).fail(function () {
            $.spinner().stop();
        });
    }
}

$(document).on('click', '.not-enabled', function (e) {
    e.preventDefault();
    var toastText = $('.byo-product').data('byo-selection-error');
    var $toast = toastMessage(toastText);
    $('.generic-toast-message-wrapper').empty();
    $('.generic-toast-message-wrapper').append($toast);
    setTimeout(function () {
        $toast.fadeOut(3000, function () {
            $(this).remove();
        });
    }, 5000);
    $('html, body').animate({
        scrollTop: $('.bundle-list-details-container').offset().top
    }, 100);
});

// Keep the subscription module in view around the login modal on mobile (AC6, SC-17165)
$(document).on('shown.bs.modal hidden.bs.modal', '#subscriptionLoginModal', function () {
    var isMobileViewport = window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches;
    var $ogWrapper = $('.og-wrapper');
    if (isMobileViewport && $ogWrapper.length) {
        $('html, body').animate({
            scrollTop: $ogWrapper.offset().top
        }, 100);
    }
});

/**
 * Overriding base.js addToCart function with clyde and custom changes
 * */
function addToCart() {
    $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        // updating optin data in cart on click on add to cart
        var isSodaSense = false;
        var loginRequiredProduct = false;
        var optinData = window && window.OG && window.OG.getOptins();
        var targetEle = $('og-offer') || $('.og-offer');
        var isSubscribed = targetEle.length > 0 ? targetEle.attr('subscribed') === '' : false;
        var isLoggedIn = $('#isloggedIn').val() === 'true';
        if ($(this).hasClass('plp-add-to-cart') && $(this).hasClass('plp-add-to-cart') === true){
            isSodaSense = $(this).closest('.product-tile').hasClass('co2Journey')
        }
        else {
            isSodaSense = $('.pdp-co2Journey').length > 0;
            loginRequiredProduct = $('.pdp-co2Journey').length > 0 && $('.pdp-co2Journey').data('must-log-in');
        }

        var hasModalOpened = sessionStorage.getItem('sodaSenseModalOpened');

        if (isSodaSense && !isLoggedIn && !hasModalOpened || (isSodaSense && loginRequiredProduct && !isLoggedIn)) {
            var productId = $(this).data('pid');

            sessionStorage.setItem('sodaSenseModalProductId', productId);
            sessionStorage.setItem('sodaSenseModalOpened', 'true');

            $('#sodaSenseLoginModal').modal('show');
            return;
        }

        isSubscribed = $('og-offer[subscribed], .og-offer[subscribed]').length > 0;
        if (isSubscribed && !isLoggedIn) {
            sessionStorage.setItem(SUBSCRIPTION_RESUME_URL_KEY, window.location.href);
            $('#subscriptionLoginModal').modal('show');
            return;
        }

        var clydeWidgets = (typeof ClydeSitePreferences !== 'undefined' && ClydeSitePreferences.CLYDE_WIDGET_ENABLED) || false;
        var clydeContainer = $('#clyde-cta');
        if (clydeWidgets && clydeContainer.length) {
            var selectedContract = Clyde.getSelectedContract();
            var clydeSettings = Clyde.getSettings();
            if (clydeSettings && clydeSettings.productPage === true) {
                if (selectedContract) {
                    clydeAddProductToCart($(this), isSubscribed, optinData);
                } else {
                    var product = Clyde.getActiveProduct();
                    var hasContracts = product && product.contracts ? product.contracts.length > 0 : false;
                    if (hasContracts && clydeSettings.modal === true) {
                        Clyde.showModal(null, clydeAddProductToCart);
                    } else {
                        clydeAddProductToCart($(this), isSubscribed, optinData);
                    }
                }
            } else if (clydeSettings && clydeSettings.modal === true) {
                Clyde.showModal(null, clydeAddProductToCart);
            } else {
                clydeAddProductToCart($(this), isSubscribed, optinData)
            }
        } else if (!$(this).hasClass('not-enabled')) { // To BYO bundle product's selected or not
            clydeAddProductToCart($(this), isSubscribed, optinData);
        }
        
    });
}

/**
 * Overriding base.js availability function 
 * */
function availability() {
    $(document).on('change', '.quantity-select', function (e) {
        e.preventDefault();

        var $productContainer = $(this).closest('.product-detail');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.modal-content').find('.product-quickview');
        }

        if ($('.bundle-items', $productContainer).length === 0) {
            attributeSelect(
                $(e.currentTarget).find('option:selected').data('url'),
                $productContainer
            );
        }
    });
}

/**
 * Override selectAttribute to support bonus product modal (product-quickview container)
 */
function selectAttribute() {
    $(document).on('change', 'select[class*="select-"], .options-select', function (e) {
        e.preventDefault();

        var $productContainer = $(this).closest('.set-item');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.product-detail');
        }
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.product-quickview');
        }
        attributeSelect(e.currentTarget.value, $productContainer);
    });
}

/**
 * Returns total quantity of selected bonus products (sum of qty).
 * Display shows quantity (e.g. 3 for 1 product x qty 3) to match Cart modal's selectedBonusProductsTotalQty.
 * @returns {number} Total quantity of selected bonus products
 */
function getTotalBonusProductQty() {
    var total = 0;
    $('#chooseBonusProductModal .selected-pid').each(function () {
        total += parseInt($(this).data('qty'), 10) || 0;
    });
    return total;
}

/**
 * Binds click handler for selecting a bonus product in the choice-of-bonus-product modal
 */
function selectBonusProduct() {
    $(document).off('click.selectBonusProduct', '.select-bonus-product')
        .on('click.selectBonusProduct', '.select-bonus-product', function () {
            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
            var pid = $(this).data('pid');
            var maxPids = parseInt($('.choose-bonus-product-dialog').data('total-qty'), 10) || 0;
            var submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
            var totalQty = 0;
            $.each($('#chooseBonusProductModal .selected-pid'), function () {
                totalQty += parseInt($(this).data('qty'), 10) || 0;
            });
            totalQty += submittedQty;
            var optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
            var valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
            if (totalQty <= maxPids) {
                var $modalFooter = $('#chooseBonusProductModal .modal-footer');
                var $existingWrapper = $modalFooter.find('.selected-pid-wrapper');
                var selectedPidHtml = '<div class="selected-pid mb-2 d-flex" '
                + 'data-pid="' + pid + '"'
                + 'data-qty="' + submittedQty + '"'
                + 'data-optionID="' + (optionID || '') + '"'
                + 'data-option-selected-value="' + (valueId || '') + '"'
                + '>'
                + '<div class="col-sm-11 col-md-8 bonus-product-name" >'
                + $choiceOfBonusProduct.find('.product-name').text()
                + '</div>'
                + '<div class="col-1 remove-bonus-product"><i class="fa fa-times" aria-hidden="true"></i></div>'
                + '</div>';
                var selectedBonusProductHtml = $existingWrapper.length
                    ? selectedPidHtml
                    : '<div class="selected-pid-wrapper w-100 m-0 mt-2 align-items-center">' + selectedPidHtml + '</div>';
                ($existingWrapper.length ? $existingWrapper : $modalFooter).append(selectedBonusProductHtml);
                $('.pre-cart-products').html(getTotalBonusProductQty());
                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
            } else {
                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
            }
        });
}

/**
 * Binds click handler for removing a selected bonus product from the modal
 */
function removeBonusProduct() {
    $(document).on('click', '.selected-pid', function () {
        $(this).remove();
        $('.pre-cart-products').html(getTotalBonusProductQty());
        $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
    });
}

/**
 * Keeps bonus product select button state in sync after variant/option changes.
 * Disables selection for non-orderable, unavailable, or coming-soon variants.
 */
function enableBonusProductSelection() {
    $('body').off('bonusproduct:updateSelectButton.coreBonusCta')
        .on('bonusproduct:updateSelectButton.coreBonusCta', function (e, response) {
            var isDisabled = !response.product.readyToOrder
                || !response.product.available
                || !!response.product.comingSoon;
            $('button.select-bonus-product', response.$productContainer).attr('disabled', isDisabled);
            $('button.select-bonus-product', response.$productContainer).data('pid', response.product.id);
        });
}

/**
 * Binds click handler for adding selected bonus products to cart.
 * Empty bonusProducts array is sent when user clears selection and clicks Add;
 * server (Cart-AddBonusProducts) treats it as "remove all bonus products" and returns success.
 */
function addBonusProductsToCart() {
    $(document).off('click', '.add-bonus-products').on('click', '.add-bonus-products', function () {
        var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
        var queryString = '?pids=';
        var url = $('.choose-bonus-product-dialog').data('addtocarturl');
        var pidsObject = {
            bonusProducts: []
        };

        // totalQty = max allowed (from data-total-qty). Server uses it as qtyAllowed for validation.
        pidsObject.totalQty = parseInt($('.choose-bonus-product-dialog').data('total-qty'), 10) || 0;

        $.each($readyToOrderBonusProducts, function () {
            var qtyOption = parseInt($(this).data('qty'), 10);

            var option = null;
            if (qtyOption > 0) {
                if ($(this).data('optionid') && $(this).data('option-selected-value')) {
                    option = {};
                    option.optionId = $(this).data('optionid');
                    option.productId = $(this).data('pid');
                    option.selectedValueId = $(this).data('option-selected-value');
                }
                pidsObject.bonusProducts.push({
                    pid: $(this).data('pid'),
                    qty: qtyOption,
                    options: [option]
                });
            }
        });
        queryString += JSON.stringify(pidsObject);
        queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
        queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
        $.spinner().start();
        $.ajax({
            url: url + queryString,
            method: 'POST',
            success: function (data) {
                $.spinner().stop();
                if (data.error) {
                    $('#chooseBonusProductModal').modal('hide');
                    var $errorToast = toastMessage(data.valid.message);
                    if ($('.generic-toast-message-wrapper').length === 0) {
                        $('body').append('<div class="generic-toast-message-wrapper" role="alert" aria-live="polite" aria-atomic="true"></div>');
                    }
                    $('.generic-toast-message-wrapper').empty().append($errorToast);
                    setTimeout(function () {
                        $errorToast.fadeOut(3000, function () {
                            $(this).remove();
                        });
                    }, 3000);
                } else {
                    // Combined main+gift add_to_cart event already fired server-side
                    // (Cart-AddBonusProducts) - clear the stash so the modal-close fallback
                    // in initChooseBonusProductModalHandlers doesn't double-report it.
                    if (window.gtmTagManager && typeof window.gtmTagManager.clearPendingBonusMainItems === 'function') {
                        window.gtmTagManager.clearPendingBonusMainItems();
                    }
                    $('.configure-bonus-product-attributes').html(data);
                    $('.bonus-products-step2').removeClass('hidden-xl-down');
                    $('#chooseBonusProductModal').modal('hide');
                    $('.minicart-quantity').html(data.totalQty);

                    var $toast = successToastMessage(data.msgSuccess);
                    if ($('.generic-toast-message-wrapper').length === 0) {
                        $('body').append('<div class="generic-toast-message-wrapper" role="alert" aria-live="polite" aria-atomic="true"></div>');
                    }
                    $('.generic-toast-message-wrapper').empty().append($toast);
                    setTimeout(function () {
                        $toast.fadeOut(3000, function () {
                            $(this).remove();
                        });
                       
                        if ($('.cart-page').length) {
                            $.spinner().start();
                            setTimeout(function () {
                                window.location.reload();
                            }, 2000);
                        }
                    }, 3000);
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

}

/**
 * Opens the choose bonus product modal for editing
 * @param {Object} data - Data for the bonus product modal
 */
function editBonusProducts (data) {
    chooseBonusProducts(data);
};

/**
 * Initializes event handlers for the choose bonus product modal
 */
function initChooseBonusProductModalHandlers() {
    $('body').on('shown.bs.modal', '#chooseBonusProductModal', function () {
        rearrangeColorSwatchesinModal();
    });

    // Modal closed (X / backdrop / Esc, or after a confirm) - fire the main-only add_to_cart
    // fallback if the choose-bonus-product flow never confirmed. No-op after a successful
    // confirm, since addBonusProductsToCart already cleared the stash.
    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        if (window.gtmTagManager && typeof window.gtmTagManager.fireBonusModalFallbackIfPending === 'function') {
            window.gtmTagManager.fireBonusModalFallbackIfPending();
        }
    });

    // Delegated handler for remain-swatch toggle - works for modal from PDP or cart page
    $('body').off('click.remainSwatchBonus keydown.remainSwatchBonus', '#chooseBonusProductModal .js-remain-swatch-bonus')
        .on('click.remainSwatchBonus keydown.remainSwatchBonus', '#chooseBonusProductModal .js-remain-swatch-bonus', function (e) {
            if (e.type === 'click' || e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
                e.preventDefault();
                var $link = $(this);
                var $wrapper = $link.closest('.remain-swatch-wrapper');
                var groupId = $wrapper.attr('data-visible-group') || $wrapper.data('visible-group');
                var $hiddenGroup = groupId ? $('#' + groupId) : $();

                if ($hiddenGroup.length) {
                    $hiddenGroup.toggleClass('visible');
                    $wrapper.toggleClass('d-none');
                    $link.attr('aria-expanded', $hiddenGroup.hasClass('visible'));
                    $hiddenGroup.attr('aria-hidden', !$hiddenGroup.hasClass('visible'));
                }
            }
        });
}
/**
 * Retrieves the guest wishlist product IDs stored in session storage.
 * @returns {Array} Array of guest wishlist product IDs, or an empty array if none exist/parse fails.
 */
function getGuestWishlist() {
    var raw = sessionStorage.getItem(GUEST_WISHLIST_KEY);
    if (!raw) return null;
    try {
        return JSON.parse(raw) || null;
    } catch (e) {
        return null;
    }
}
 
/**
 * Syncs guest wishlist items to the logged-in user's account after a successful login/register.
 * Clears the guest wishlist on success and marks the corresponding wishlist buttons as added.
 * after successful login/register (AJAX .done() callback):
 * @returns {void}
 */
function mergeGuestWishlistAfterLogin() {
    var pid = getGuestWishlist();
    if (!pid) {
        return;
    }
 
    const url = $('#guestWishListURL').val();
    const params = new URLSearchParams(url.split('?')[1]);
    const isRegisterd = params.get('isRegisterd');
    if (isRegisterd === "true") {
        $.ajax({
            url: url,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                pid: pid
            }),
            dataType: 'json',
            success: function (data) {
                if (data && data.success) {
                    sessionStorage.removeItem(GUEST_WISHLIST_KEY);
                }
            }
        });
    }
}
 
if (!window.guestWishlistMerged) {
    window.guestWishlistMerged = true;
    mergeGuestWishlistAfterLogin();
}

/**
 * Re-selects the OrderGroove subscribe option after a shopper is redirected back to the PDP
 * from the subscription login/create-account modal (SC-17165, AC5). Polls briefly for the
 * widget's toggle element since it mounts asynchronously.
 * @returns {void}
 */
function resumeSubscriptionAfterLogin() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('resumeSubscription') !== 'true' || $('#isloggedIn').val() !== 'true') {
        return;
    }

    var attempts = 0;
    var intervalId = setInterval(function () {
        attempts += 1;
        var isSubscribed = $('og-offer[subscribed], .og-offer[subscribed]').length > 0;
        var $toggle = $('og-optin-toggle, .og-optin-button-item').first();
        if (isSubscribed || attempts > 20) {
            clearInterval(intervalId);
        } else if ($toggle.length) {
            $toggle.trigger('click');
            clearInterval(intervalId);
        }
    }, 300);
}

if (!window.subscriptionResumeChecked) {
    window.subscriptionResumeChecked = true;
    resumeSubscriptionAfterLogin();
}

/**
 * Handles add to cart for widget product-tile and PDP card buttons.
 * Tile buttons supply data-product-id; PDP card buttons supply data-sku + data-quantity.
 */
function setWidgetTitleLabel() {
    var el = document.getElementById('cimulate-messaging-widget');
    var label = (el && el.dataset.askLabel) || 'Ask';
    document.documentElement.style.setProperty('--cc-ask-label', "'" + label + "'");
}

/**
 * Handles widget add to cart functionality related to product-tile, compare and PDP card buttons.
 */
function widgetAddToCart() {
    $(document).off('click.snWidgetAtc').on('click.snWidgetAtc', '.cim-widget-msg-product-card__cta--cart, .cim-widget-msg-pdp__add-to-cart', function (e) {
        e.preventDefault();

        var $btn = $(this);
        var pid = $btn.data('product-id');
        if (!pid) return;

        var addToCartUrl = getAddToCartUrl($btn);
        if (!addToCartUrl) return;

        $btn.prop('disabled', true);
        // $('body').trigger('product:beforeAddToCart', this);

        getAddToCartUrlWithToken(addToCartUrl, getAddToCartCsrfToken($btn)).then(function (urlWithToken) {
            $.ajax({
                url: urlWithToken,
                method: 'POST',
                data: {
                    pid: pid,
                    quantity: 1
                },
                success: function (data) {
                    // handlePostCartAdd(data);
                    // $('body').trigger('product:afterAddToCart', data);
                    $btn.prop('disabled', false);

                    if (!data.error) {
                        var $msg = $(
                            '<div class="cim-widget-add-to-cart-success" role="status">'
                            + '<span class="cim-widget-add-to-cart-success__icon"></span>'
                            + '<span class="cim-widget-add-to-cart-success__text">' + (data.message || '') + '!</span>'
                            + '</div>'
                        );
                        $btn.after($msg);
                        $btn[0].dispatchEvent(new CustomEvent('sn:add-to-cart-success', { bubbles: true }));
                        setTimeout(function () {
                            $msg.fadeOut(500, function () { $(this).remove(); });
                        }, 3000);
                    } else {
                        var $errMsg = $(
                            '<div class="cim-widget-add-to-cart-error" role="alert">'
                            + '<span class="cim-widget-add-to-cart-error__text">' + (data.message || '') + '</span>'
                            + '</div>'
                        );
                        $btn.after($errMsg);
                        setTimeout(function () {
                            $errMsg.fadeOut(500, function () { $(this).remove(); });
                        }, 3000);
                    }
                },
                error: function () {
                    $btn.prop('disabled', false);
                }
            });
        }).fail(function () {
            $btn.prop('disabled', false);
        });
    });
}

baseProducts.addToCart = addToCart;
baseProducts.colorAttribute = colorAttribute;
baseProducts.selectAttribute = selectAttribute;
baseProducts.availability = availability;
baseProducts.ltkUpdateCartData = ltkUpdateCartData;
baseProducts.ltkAppendSCAScript = ltkAppendSCAScript;
baseProducts.selectBonusProduct = selectBonusProduct;
baseProducts.removeBonusProduct = removeBonusProduct;
baseProducts.enableBonusProductSelection = enableBonusProductSelection;
baseProducts.addBonusProductsToCart = addBonusProductsToCart;
baseProducts.handlePostCartAdd = handlePostCartAdd;
baseProducts.widgetAddToCart = widgetAddToCart;
baseProducts.setWidgetTitleLabel = setWidgetTitleLabel;
baseProducts.methods.editBonusProducts = editBonusProducts;

$(function () {
    initChooseBonusProductModalHandlers();
    subscriptionPrice.init();
    $('body').on('product:beforeAttributeSelect', function (e, params) {
        subscriptionPrice.beforeVariant(params && params.container);
    });
    $('body').on('product:afterAttributeSelect', function (e, params) {
        subscriptionPrice.afterVariant(params && params.data && params.data.product, params && params.container);
    });
    $('body').on('quickview:ready', function () {
        subscriptionPrice.quickView.init();
    });
    $('body').on('hidden.bs.modal', '#quickViewModal', function () {
        subscriptionPrice.quickView.stop();
    });
});

module.exports = baseProducts;
